import React, { useEffect, useState } from "react";
import { InputCode } from "./auth/InputCode";
import { codeService } from "../services/code.service";

interface ConfirmCodeProps {
    phoneNumber: string;
    onChangeNumber: () => void;
    error?: string;
    onCompleteCode: (phone: string, code: string) => void;
}

export const ConfirmCode: React.FC<ConfirmCodeProps> = ({
                                                            phoneNumber,
                                                            onChangeNumber,
                                                            onCompleteCode,
                                                        }) => {
    const [timer, setTimer] = useState<NodeJS.Timer>();
    const [time, setTime] = useState(60);
    const [error, setError] = useState('');

    const sendCode = (code: string) => {
        codeService.check(phoneNumber, code).then(result => {
            if(result.isValid) {
                onCompleteCode(phoneNumber, code);
            }
        }).catch(error => setError(error.response.data.message));
    }

    const resendCode = () => {
        startTimer();
    }

    const startTimer = () => {
        setTime(60);
        const interval = setInterval(() => setTime(oldTime => oldTime - 1), 1000);
        setTimer(interval);
    }

    useEffect(() => {
        startTimer();
    }, []);

    useEffect(() => {
          if(time <= 0) {
              clearInterval(timer);
          }
    }, [time, timer]);
    
    return (
        <div className="bg-white rounded-2xl p-5">
            <div className="w-full mb-4">
                <p className="text-sm text-gray font-medium">Код отправлен на номер { phoneNumber }</p>
                <p className="text-sm cursor-pointer font-medium" onClick={ () => onChangeNumber() }>Изменить</p>
            </div>
            <div className="w-full mb-8">
                <InputCode length={ 4 } onCompleteCode={ sendCode } startFocus={ true }/>
                { error && <p className="text-error text-sm">{ error }</p> }
            </div>
            <div className="w-full mb-6">
                { time ?
                    <p className="text-sm text-gray font-medium">Повторно код можно отправить через { time } с</p> :
                    <p className="cursor-pointer" onClick={ () => resendCode() }>Отправить код повторно</p> }
            </div>
        </div>
    )
}